import { render, staticRenderFns } from "./SelectLang.vue?vue&type=template&id=695b1de7&scoped=true"
import script from "./SelectLang.vue?vue&type=script&lang=js"
export * from "./SelectLang.vue?vue&type=script&lang=js"
import style0 from "./SelectLang.vue?vue&type=style&index=0&id=695b1de7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695b1de7",
  null
  
)

export default component.exports